import * as React from 'react';
import * as styles from './KpInfo.css';
import { Link } from '../../common/components/link';
import { IKPSchema, IOfferSchema, IAgentSchema, TCategory } from '@cian/api-models/offer-card/v1/get-offer-data';
import { mergeStyles } from '@cian/utils/lib/shared/style';
import { trackKPLinkClick } from '../../utils/countrySideCardIntegrationTracking';

const villageClassNames = {
  business: 'Бизнес',
  comfort: 'Комфорт',
  economy: 'Эконом',
  elite: 'Элитный',
};

const offerCategories = {
  cottageSale: 'cottageSale' as TCategory,
  townhouseSale: 'townhouseSale' as TCategory,
  houseSale: 'houseSale' as TCategory,
  houseShareSale: 'houseShareSale' as TCategory,
  landSale: 'landSale' as TCategory,
};

const offerCategoryNames = {
  [offerCategories.cottageSale]: 'Коттедж',
  [offerCategories.townhouseSale]: 'Таунхаус',
  [offerCategories.houseSale]: 'Дом',
  [offerCategories.houseShareSale]: 'Объект',
  [offerCategories.landSale]: 'Участок',
};

export interface IKpInfoProps {
  kp: IKPSchema | null;
  offer: IOfferSchema;
  agent: IAgentSchema | null;
}

export class KpInfo extends React.Component<IKpInfoProps, {}> {
  public render() {
    const { kp, offer } = this.props;

    return (
      <>
        {kp && (
          <div className={styles['kp_info_container']}>
            <div className={styles['kp_info_header']}>
              <span>{offerCategoryNames[offer.category] || 'Объект'} находится в посёлке </span>
              {kp.url ? (
                <Link
                  className={styles['link']}
                  href={kp.url}
                  target="_blank"
                  rel="noopener"
                  onClick={this.handleHeaderLinkClick}
                >
                  «{kp.name}»
                </Link>
              ) : (
                <span>«{kp.name}»</span>
              )}
            </div>
            <div className={styles['kp_info_body']}>
              {kp.url ? (
                <Link href={kp.url} target="_blank" rel="noopener" onClick={this.handlePictureLinkClick}>
                  <div {...mergeStyles([styles['kp_info_thumb'], { backgroundImage: `url(${kp.imageUrl})` }])}>
                    <div className={styles['kp_info_thumb_link']}>
                      <div className={styles['kp_info_thumb_text']}>Ещё фото</div>
                    </div>
                  </div>
                </Link>
              ) : (
                <div {...mergeStyles([styles['kp_info_thumb'], { backgroundImage: `url(${kp.imageUrl})` }])}>
                  <div className={styles['kp_info_thumb_link']} />
                </div>
              )}
              {kp.villageClass && this.renderInfoItem('Класс', villageClassNames[kp.villageClass])}
              {kp.counterSet &&
                kp.counterSet.total !== undefined &&
                this.renderInfoItem('Объектов', String(kp.counterSet.total))}
              {kp.counterSet &&
                kp.counterSet.onSale !== undefined &&
                this.renderInfoItem('В продаже', String(kp.counterSet.onSale))}
              {kp.counterSet &&
                kp.counterSet.sold !== undefined &&
                this.renderInfoItem('Куплено', String(kp.counterSet.sold))}
              {kp.counterSet &&
                kp.counterSet.underConstruction !== undefined &&
                this.renderInfoItem('Строится', String(kp.counterSet.underConstruction))}
            </div>
          </div>
        )}
      </>
    );
  }

  private handleHeaderLinkClick = () => {
    const { offer, agent, kp } = this.props;
    trackKPLinkClick('card_name_kp_block_in_newlist', offer, agent, kp && kp.id);
  };

  private handlePictureLinkClick = () => {
    const { offer, agent, kp } = this.props;
    trackKPLinkClick('card_photo_block_in_newlist', offer, agent, kp && kp.id);
  };

  private renderInfoItem = (name: string, value: string) => {
    return (
      <div className={styles['kp_info_item']}>
        <div className={styles['kp_info_item_header']}>{name}</div>
        <div>{value}</div>
      </div>
    );
  };
}
